// Pedido de "Rever o tour" (ADR-0104). Evento de janela em vez de contexto:
// quem pede (menu do usuário, botão de ajuda) e quem mostra (o tour, montado
// uma vez no shell) não precisam de provider em comum.

const EVENTO = "pharu:rever-tour";

export function pedirTour() {
  window.dispatchEvent(new CustomEvent(EVENTO));
}

export function aoPedirTour(callback) {
  window.addEventListener(EVENTO, callback);
  return () => window.removeEventListener(EVENTO, callback);
}
